import { createReducer } from 'redux-create-reducer'
import {
  PRELOAD_DATA_ON_LOGIN,
  PUBLISHERS_ADD_SUCCESS,
  PUBLISHERS_UPDATE_SUCCESS,
} from '@disco/constants/ActionTypes'
const initialState: Array<any> = []
export type PublishersState = typeof initialState
export const publishersReducer = createReducer<PublishersState, any>(
  initialState,
  {
    [PRELOAD_DATA_ON_LOGIN](_state, action) {
      return action.entities.publishers || initialState
    },

    [PUBLISHERS_ADD_SUCCESS](state, { publishers }) {
      return [...state, ...publishers]
    },

    [PUBLISHERS_UPDATE_SUCCESS](state, { publisher }) {
      return state.map(p =>
        p.id === publisher.id ? { ...p, ...publisher } : p,
      )
    },
  },
)
